import { useMemo } from 'react';

import { AdditionalEntitlement } from '@dreryk/egabinet-prescription-frontend-api';

import {
   findReimbursementByType,
   MedicinePrescriptionReimbursement,
   PatientReimbursement,
   Reimbursement,
   ReimbursementType,
   selectReimbursement,
} from '~libs.shared.prescription';

type ReimbursementSelectorOptions = {
   initialReimbursementType: ReimbursementType | undefined;
   selectedPatientReimbursementByUser: PatientReimbursement | undefined;
   additionalEntitlements: AdditionalEntitlement[];
   reimbursements: MedicinePrescriptionReimbursement[];
};

export const useReimbursementSelector = (options: ReimbursementSelectorOptions): Reimbursement | null => {
   return useMemo(
      () => {
         if (options.selectedPatientReimbursementByUser) {
            return selectReimbursement({
               selectedReimbursement: options.selectedPatientReimbursementByUser,
               additionalEntitlements: options.additionalEntitlements,
               reimbursements: options.reimbursements,
            });
         }

         return selectReimbursement({
            reimbursement: findReimbursementByType(options.initialReimbursementType ?? 'FULL', options.reimbursements),
            reimbursements: options.reimbursements,
         });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
   );
};
